(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["space-halloween-offer"] && !Shopify.designMode) return;
  try {
    
if (!window.spaceHalloweenCopyInstalled) {
  window.spaceHalloweenCopyInstalled = true;
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-halloween-copy]');
    if (!button) return;
    const status = button.parentElement.querySelector('[role="status"]');
    try {
      await navigator.clipboard.writeText(button.dataset.halloweenCopy);
      button.textContent = button.dataset.copiedLabel;
      status.textContent = button.dataset.copiedLabel;
    } catch {
      status.classList.remove('sr-only');
      status.textContent = button.dataset.copyError;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["space-halloween-popup"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('space-halloween-popup')) {
  customElements.define('space-halloween-popup', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      this.launcher = this.querySelector('[data-popup-open]');
      this.launcher.addEventListener('click', () => this.open());
      this.key = 'space:halloween:2026:popup:seen';
      this.preview = this.dataset.preview === 'true' || new URLSearchParams(location.search).get('halloween_popup_preview') === '1';
      this.querySelector('[data-popup-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('halloween-popup-open');
        this.launcher.hidden = Date.now() >= Date.parse(this.dataset.expires);
        this.launcher.setAttribute('aria-expanded', 'false');
        if (!this.launcher.hidden) this.launcher.focus({ preventScroll: true });
      });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
      this.querySelector('[data-popup-copy]').addEventListener('click', async event => {
        const button = event.currentTarget;
        const status = this.querySelector('[role="status"]');
        try {
          await navigator.clipboard.writeText(this.querySelector('[data-popup-code]').textContent.trim());
          button.textContent = button.dataset.copied;
          status.textContent = button.dataset.copied;
        } catch {
          status.classList.remove('sr-only');
          status.textContent = button.dataset.error;
        }
      });
      const begin = () => this.tryOpen();
      this.begin = begin;
      if (document.readyState === 'complete') begin();
      else window.addEventListener('load', begin, { once: true });
    }
    tryOpen() {
      if (!this.isConnected || Date.now() >= Date.parse(this.dataset.expires)) return;
      let seen = window.spaceHalloweenPopupSeen === true;
      try { seen = seen || sessionStorage.getItem(this.key) === '1'; } catch {}
      if (seen && !this.preview) {
        this.launcher.hidden = false;
        return;
      }
      if (document.hidden || document.querySelector('dialog[open], .drawer[open], .pop-in[open]')) {
        this.timer = setTimeout(() => this.tryOpen(), 750);
        return;
      }
      this.open();
    }
    open() {
      clearTimeout(this.timer);
      if (Date.now() >= Date.parse(this.dataset.expires)) {
        this.launcher.hidden = true;
        return;
      }
      this.launcher.hidden = true;
      this.launcher.setAttribute('aria-expanded', 'true');
      if (!this.dialog.open) this.dialog.showModal();
      document.documentElement.classList.add('halloween-popup-open');
      window.spaceHalloweenPopupSeen = true;
      try { sessionStorage.setItem(this.key, '1'); } catch {}
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      window.removeEventListener('load', this.begin);
      if (this.dialog?.open) this.dialog.close();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["space-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('space-newsletter')) {
    customElements.define('space-newsletter', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.setup(), { once: true });
        else this.setup();
      }
      setup() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;
        this.launcher = this.querySelector('[data-newsletter-open]');
        this.form = this.querySelector('form');
        this.key = 'space:newsletter:v1';
        this.pendingKey = this.key + ':pending';
        this.memory = {};
        const saved = this.read();
        const state = this.querySelector('[data-newsletter-state]').dataset.newsletterState;
        let pending = false;
        try {
          const submission = JSON.parse(sessionStorage.getItem(this.pendingKey) || 'null');
          pending = submission?.formId === this.dataset.formId && Date.now() - submission.at < 1800000;
        } catch {}
        // Shopify's rendered form state is the confirmation; a pending submission only identifies this popup.
        const ownResponse = state !== 'initial' && (location.hash === '#' + this.dataset.formId || pending);
        if (ownResponse) {
          try { sessionStorage.removeItem(this.pendingKey); } catch {}
        }
        this.form.addEventListener('submit', () => {
          try {
            sessionStorage.setItem(this.pendingKey, JSON.stringify({ formId: this.dataset.formId, at: Date.now() }));
          } catch {}
        });
        this.subscribed = this.dataset.subscribed === 'true' || saved.subscribed === true;
        if (ownResponse && state === 'success') {
          this.subscribed = true;
          this.write({ subscribed: true });
        }
        this.launcher.hidden = this.subscribed;
        this.launcher.addEventListener('click', () => this.open());
        this.querySelectorAll('[data-newsletter-close]').forEach(button => button.addEventListener('click', () => this.dialog.close()));
        this.dialog.addEventListener('close', () => {
          this.write({ dismissedAt: Date.now() });
          this.launcher.hidden = this.subscribed;
        });
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        });
        const copy = this.querySelector('[data-newsletter-copy]');
        if (copy) copy.addEventListener('click', async () => {
          const code = this.querySelector('[data-newsletter-code]');
          try {
            await navigator.clipboard.writeText(code.textContent.trim());
            copy.textContent = copy.dataset.copiedLabel;
          } catch {
            const range = document.createRange();
            range.selectNodeContents(code);
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
          }
        });
        if (ownResponse || (new URLSearchParams(location.search).get('space_newsletter_preview') === '1')) this.open();
        else if (!this.subscribed && Date.now() - Number(saved.dismissedAt || 0) >= Number(this.dataset.repeatHours) * 3600000) {
          this.timer = setTimeout(() => {
            if (document.querySelector('dialog[open], .drawer[open], .pop-in[open]')) return;
            this.open();
          }, Number(this.dataset.delay) * 1000);
        }
      }
      read() {
        try { return JSON.parse(localStorage.getItem(this.key) || '{}') || {}; }
        catch { return this.memory; }
      }
      write(value) {
        this.memory = { ...this.read(), ...value };
        try { localStorage.setItem(this.key, JSON.stringify(this.memory)); } catch {}
      }
      open() {
        clearTimeout(this.timer);
        if (!this.dialog.open) this.dialog.showModal();
        this.querySelector('[data-newsletter-close]').focus({ preventScroll: true });
      }
      disconnectedCallback() { clearTimeout(this.timer); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
